import { Helmet } from 'react-helmet-async';

import CompSetList from './ManageSets/compSetList';

const SetManagementPage: React.FC = () => {
  return (
    <div className="container mt-4 mb-5">
      <Helmet>
        <title>Manage Sets</title>
      </Helmet>
      <h3>Manage Sets:</h3>

      <div className="row">
        <div className="col">
          <CompSetList />
        </div>
      </div>
    </div>
  );
};

export default SetManagementPage;
